import Carousel from 'react-material-ui-carousel';
import { Box } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { useContext } from 'react';
import { AppContext } from '../../context/AppContextProvider';

export interface ICarrouselImagesComponentProps {
  items: any;
  autoPlay?: boolean;
  animation?: 'slide' | 'fade';
  cycleNavigation?: boolean;
  duration?: number;
  interval?: number;
  stopAutoPlayOnHover?: boolean;
  height?: string;
}

const CarrouselImagesComponent = ({
  items,
  autoPlay,
  animation,
  cycleNavigation,
  duration,
  height,
  interval,
  stopAutoPlayOnHover,
}: ICarrouselImagesComponentProps) => {
  const { setIsShowLoadingComponent } = useContext(AppContext);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        textAlign: 'center',
      }}
    >
      <Carousel
        autoPlay={autoPlay || false}
        animation={animation || 'slide'}
        stopAutoPlayOnHover={stopAutoPlayOnHover || true}
        cycleNavigation={cycleNavigation || true}
        duration={duration || 400}
        interval={interval || 2000}
        NextIcon={<ArrowForward />}
        PrevIcon={<ArrowBack />}
        navButtonsProps={{
          style: {
            backgroundColor: '#1A2035',
            borderRadius: 50,
            color: '#fff',
          },
        }}
        navButtonsWrapperProps={{
          style: {
            top: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: 'transparent',
          },
        }}
        indicatorContainerProps={{
          style: {
            marginTop: '10px',
            textAlign: 'center',
          },
        }}
        indicatorIconButtonProps={{
          style: {
            backgroundColor: '#fff',
            color: '#fff',
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            margin: '0 4px',
          },
        }}
        activeIndicatorIconButtonProps={{
          style: {
            backgroundColor: '#1565C0',
            color: '#1565C0',
            width: '14px',
            height: '14px',
          },
        }}
      >
        {items.map((i: any, idx: number) => (
          <img
            key={idx}
            src={i}
            alt={`Image ${idx}`}
            onLoad={() => setIsShowLoadingComponent(false)}
            style={{ maxWidth: '100%', maxHeight: '500px' }}
          />
        ))}
      </Carousel>
    </Box>
  );
};

export default CarrouselImagesComponent;
